import RouterSection from '@/layout/components/RouterSection'

const ADMIN_ROLES = ['usergroup001', 'usergroup002', 'usergroup003']
const ADMIN_ROLES_004 = ['usergroup001', 'usergroup002', 'usergroup003', 'usergroup004', 'usergroup008']

export default {
  path: '/master',
  name: 'master_home',
  component: RouterSection,
  redirect: { name: 'SiteManage' },
  meta: { roles: ADMIN_ROLES_004 },
  children: [
    {
      path: 'siteManage',
      name: 'SiteManage',
      component: () => import('@/views/master/SiteManage.vue'),
      meta: { roles: ADMIN_ROLES_004 }
    },
    {
      path: 'siteRegister',
      name: 'SiteRegister',
      props: true,
      component: () => import('@/views/master/SiteRegister.vue'),
      meta: { roles: ADMIN_ROLES_004 }
    },
    {
      path: 'siteEssReg',
      name: 'SiteEssReg',
      props: true,
      component: () => import('@/views/master/SiteDetailESS.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'unitPriceManage',
      name: 'UnitPriceManage',
      props: true,
      component: () => import('@/views/master/UnitPriceManage.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'migration',
      name: 'Migration',
      props: true,
      component: () => import('@/views/master/Migration.vue'),
      meta: { roles: ADMIN_ROLES }
    },
    {
      path: 'siteBillManage',
      name: 'SiteBillManage',
      props: true,
      component: () => import('@/views/master/SiteBillManage.vue'),
      meta: { roles: ADMIN_ROLES }
    }
  ]
}
